import React from 'react';
import classNames from 'classnames';

import { NamedLink } from '../../../../components';

import SectionContainer from '../SectionContainer';
import css from './NewList.module.css';

export default function NewList(props) {
  const { sectionId, className, rootClassName, appearance, options } = props;

  return (
    <SectionContainer
      id={sectionId}
      className={classNames(css.root, className || '')}
      rootClassName={rootClassName}
      appearance={appearance}
      contentClassName={css.newListContentContainer}
      options={options}
    >
      <div className={css.newListCenterContainer}>
        <div className={css.newListTitleWrapper}>
          <h5>For gear owners</h5>
          <h2 className={css.newListTitlePrimary}>Gear sitting in the garage?</h2>
          <h2 className={css.newListTitleSecondary}>Put it to work.</h2>
        </div>
        <NamedLink className={css.newListButton} name="NewListingPage">
          Post a New Listing
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.08301 9.91667L9.91634 4.08333M9.91634 8.75V4.08333H5.24967"
              stroke="white"
              strokeWidth="1.05"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </NamedLink>
      </div>
    </SectionContainer>
  );
}